<template>
  <div
    class="plot-wrapper"
    :style="`width: ${settings.width}px; ` + `height: ${settings.height}px; ` + `top: ${settings.y}px; ` + `left: ${settings.x}px`"
  >
    <div class="plot-control-panel" :style="`height: ${settings.controlsHeight}px; ` + `margin-top: ${settings.controlsMargin.top}px`">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlotBasePanel",

  props: {
    settings: Object
  }
};
</script>

<style scoped>
.plot-wrapper {
  display: block;
  position: absolute !important;
}
.plot-control-panel {
  display: inline-block;
  width: calc(100% - 70px);
  margin-left: 70px;
}
</style>
